import { render, staticRenderFns } from "./RoutineContent.vue?vue&type=template&id=681210fa"
import script from "./RoutineContent.vue?vue&type=script&lang=js"
export * from "./RoutineContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports